import { useQuery, UseQueryResult } from 'react-query';
import { api } from '../api';
import { AtosaTaxpayer } from '../types/atosa';

async function getTaxpayers(): Promise<{ taxPayers: AtosaTaxpayer[] }> {
    const { data } = await api.get('/atosa/taxpayers');
    return data;
}

export function useAtosaTaxpayers(): UseQueryResult<{ taxPayers: AtosaTaxpayer[] }, unknown> {
    return useQuery(['atosa', 'taxpayers'], getTaxpayers);
}
